import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";

const EditMerchantModal = ({ show, onHide, info, setLoading, getGridData }) => {
  const [infoMerchant, setInfoMerchant] = useState({});

  useEffect(() => {
    setInfoMerchant({
      id: info.id,
      merchantType: info.merchantType,
      firstName: info.firstName,
      lastName: info.lastName,
      genderType: info.genderType,
      identityNumber: info.identityNumber,
      nationalNumber: info.nationalNumber,
      mobile: info.mobile,
      phone: info.phone,
      email: info.email,
      companyName: info.companyName,
      nikCompanyName: info.nikCompanyName,
      economicCode: info.economicCode,
      registrationNumber: info.registrationNumber,
      webSiteAddress: info.webSiteAddress,
      faxNumber: info.faxNumber,
      creditable: info.creditable,
      branchId: info.branchId,
    });
  }, [info]);
  const handleMerchantSave = async () => {
    setLoading(true);
    const resp = await apiMethod.createMerchant(infoMerchant);
    if (!methods.showApiErrors(resp)) return;
    setLoading(false);
    await getGridData();
    onHide();
  };


  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton>
        <span className="fw-bold">اطلاعات مشتری</span>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <div className="col-md-12">
            <label htmlFor="merchantType" className="form-label">
              نوع مشتری
            </label>
            <select
              id="merchantType"
              className="form-select"
              aria-label="Default select example"
              value={infoMerchant.merchantType}
              onChange={(e) =>
                setInfoMerchant({
                  ...infoMerchant,
                  merchantType: Number(e.target.value),
                  firstName : "",
                  lastName : "",
                  part: 1,
                })
              }
            >
              <option value="">انتخاب کنید</option>
              <option value={1}>حقیقی</option>
              <option value={2}>حقوقی</option>
            </select>
          </div>
          {infoMerchant.merchantType === 1 && (
            <>
              <div className="col-md-12">
                <label
                  htmlFor="firstname"
                  className="form-label required-label"
                >
                  نام
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="firstname"
                  value={infoMerchant.firstName || ""}
                  onChange={(e) => {
                    setInfoMerchant({
                      ...infoMerchant,
                      firstName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="lastname" className="form-label required-label">
                  نام‌خانوادگی
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lastname"
                  value={infoMerchant.lastName || ""}
                  onChange={(e) => {
                    setInfoMerchant({
                      ...infoMerchant,
                      lastName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="nationalNumber" className="form-label">
                  شماره‌ملی
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="nationalNumber"
                  value={infoMerchant.nationalNumber || ""}
                  onChange={(e) => {
                    setInfoMerchant({
                      ...infoMerchant,
                      nationalNumber: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="mobile" className="form-label required-label">
                  تلفن همراه
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mobile"
                  value={methods.formatPhoneNumber(infoMerchant.mobile) || ""}
                  onChange={(e) => {
                    setInfoMerchant({
                      ...infoMerchant,
                      mobile: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="phone" className="form-label required-label">
                  تلفن ثابت
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  value={infoMerchant.phone}
                  onChange={(e) => {
                    setInfoMerchant({ ...infoMerchant, phone: e.target.value });
                  }}
                />
              </div>
            </>
          )}
          {infoMerchant.merchantType === 2 && (
            <>
              <div className="col-md-12">
                <label
                  htmlFor="firstName"
                  className="form-label required-label"
                >
                  نام شرکت
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  value={infoMerchant.firstName || ""}
                  onChange={(e) => {
                    setInfoMerchant({
                      ...infoMerchant,
                      firstName: e.target.value,
                      companyName : e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="economicCode" className="form-label">
                  شناسه اقتصادی
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="economicCode"
                  value={infoMerchant.economicCode || ""}
                  onChange={(e) =>
                    methods.validateNumberInput(e.target.value) &&
                    setInfoMerchant({
                      ...infoMerchant,
                      economicCode: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="phone" className="form-label required-label">
                  شماره موبایل
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  value={infoMerchant.mobile}
                  onChange={(e) => {
                    setInfoMerchant({
                      ...infoMerchant,
                      mobile: e.target.value,
                    });
                  }}
                />
              </div>
            </>
          )}
          <div>
            <label htmlFor="creditable" className="form-label">
              نوع اعتبار
            </label>
            <select
              id="creditable"
              className="form-select"
              aria-label="Default select example"
              value={
                infoMerchant.creditable === true
                  ? 1
                  : infoMerchant.creditable === false
                  ? 0
                  : ""
              }
              onChange={(e) =>
                setInfoMerchant({
                  ...infoMerchant,
                  creditable:
                    e.target.value === "1"
                      ? true
                      : e.target.value === "0"
                      ? false
                      : "",
                })
              }
            >
              <option value="">انتخاب کنید</option>
              <option value={1}>اعتباری</option>
              <option value={0}>غیر اعتباری</option>
            </select>
          </div>
        </div>
        <div className="col-md-12 mt-3">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={infoMerchant.creditable}
              onChange={(e) => {
                setInfoMerchant({
                  ...infoMerchant,
                  creditable: e.target.checked,
                });
              }}
            />
            <span className="me-1">مجوز استفاده از اعتبار</span>
          </label>
        </div>
        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
          <button
            type="button"
            className="btn custome-btn btn-link-purple"
            onClick={onHide}
          >
            انصراف
          </button>
          <button
            type="button"
            className="btn custome-btn btn-purple"
            onClick={handleMerchantSave}
          >
            ثبت و ذخیره
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditMerchantModal;
